import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import React, { useEffect, useState } from 'react';
import { NestedPaymentComponent } from './NestedPaymentComponent';
import { useLocation } from 'react-router';
import { stripeAppearance, stripeLoader } from 'utils/stripeAppearance';

export const PaymentComponent = ({ id, price }) => {
    // FOR LIVE
    // const stripePublicKey = process.env.REACT_APP_STRIPE_PK;
    // const stripePromise = loadStripe(stripePublicKey);

    // FOR TESTING
    const stripePublicTestKey = process.env.REACT_APP_STRIPE_TK; 
    const stripePromise = loadStripe(stripePublicTestKey);

    // BELOW IS FOR STRIPE PAYMENTS, DO NOT REMOVE DO NOT UNCOMMENT
    const [clientSecret, setClientSecret] = useState("");

    // Test Credit Card - 4242 4242 4242 4242 with any 3 digit svc and any valid date
    const location = useLocation();
    const formData = location.state?.formData;
    const formType = location.state?.formType;
    const eventName = location.state?.eventName;

    useEffect(() => {
        // Create PaymentIntent as soon as the page loads
        // Test Link: "http://localhost:4242/usyncPayments/generalPayment"
        // Live Link: "https://website-backend-5m32.onrender.com/usyncPayments/generalPayment"
        fetch("https://website-backend-5m32.onrender.com/usyncPayments/generalPayment", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ items: [{ id: id, amount: price, formData: formData, formType: formType, eventName: eventName }] }),
        })
            .then((res) => res.json())
            .then((data) => setClientSecret(data.clientSecret));
    }, []);

    return (
        <React.Fragment>
            {clientSecret && (
                <Elements options={{clientSecret, appearance: stripeAppearance, loader: stripeLoader}} stripe={stripePromise}>
                    <NestedPaymentComponent price={price} />
                </Elements>
            )}
        </React.Fragment>
    );
}
